import { SendAssessmentComponent } from "./send-assessment.component";
import { SendAssessmentResultsModalComponent } from "./sendAssessmentResultsModal/send-assessment-results-modal.component";
export var SendAssessmentModule = angular
    .module('sendAssessment', [])
    .component(SendAssessmentComponent.selector, SendAssessmentComponent.component)
    .component(SendAssessmentResultsModalComponent.selector, SendAssessmentResultsModalComponent.component)
    .name;
//# sourceMappingURL=send-assessment.module.js.map